import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DateRange } from '@angular/material/datepicker';
import { add, startOfMonth } from 'date-fns';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})
export class DateRangePickerComponent implements OnInit {
  @Input() datePicker: DateRange<dateFns> | undefined;
  @Input() minDate = null;
  @Input() maxDate = null;
  @Output() datePickerChange = new EventEmitter<DateRange<dateFns>>();

  // Private
  startDate: dateFns | null = null;
  endDate: dateFns | null = null;

  // Set the range
  range: { start: dateFns | null; end: dateFns | null } = {
    start: null,
    end: null,
  };

  // DateRange instance using range
  dateRange = new DateRange(this.range.start, this.range.end);

  // Set the months for calendar view
  firstMonth = startOfMonth(new Date());

  constructor(private _dateAdapter: DateAdapter<dateFns>) {}

  ngOnInit(): void {
    this.dateRange = this.datePicker!;
  }

  /**
   * @param date date
   * @description this function responsible of send back selected start time end time value
   * @returns void
   */
  selectedChange(date: dateFns): void {
    if (!this.startDate) {
      this.startDate = add(new Date(date.toString()), {
        hours: 0,
        minutes: 0,
        seconds: 0,
      }) as any;
    } else if (
      !this.endDate &&
      this._dateAdapter.compareDate(date, this.startDate) >= 0
    ) {
      this.endDate = add(new Date(date.toString()), {
        hours: 23,
        minutes: 59,
        seconds: 59,
      }) as any;
    } else {
      this.startDate = add(new Date(date.toString()), {
        hours: 0,
        minutes: 0,
        seconds: 0,
      }) as any;
      this.endDate = null;
    }

    this.range.start = this.startDate;
    this.range.end = this.endDate;
    this.dateRange = new DateRange(this.startDate, this.endDate);
    if (this.startDate && this.endDate) {
      this.datePickerChange.emit((this.datePicker = this.dateRange));
    } else {
      this.datePickerChange.emit((this.datePicker = undefined));
    }
  }
}
